<template>
  <BaseAlert
    v-if="showError"
    :hg-value="true"
    hg-type="error">
    <slot></slot>
  </BaseAlert>
</template>

<script>
import { Components } from '@spectorasoftware/homegauge-vue';

const { BaseAlert } = Components;

export default {
  components: {
    BaseAlert,
  },
  props: {
    showError: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
